import Timeline from "./Home/Timeline";
import Skills from "./Home/Skills";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faEnvelope,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { ReactComponent as OrcidIcon } from "../assets/orcid.svg";

export default function AboutMe() {
  return (
    <section className="w-full px-6 pt-16 pb-24">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-12">
        {/* LEFT SIDEBAR */}
        <aside className="lg:sticky lg:top-28 h-fit">
          {/* MOBILE COMPACT HEADER (shown < lg) */}
          <div className="lg:hidden flex items-center gap-4">
            <div className="w-16 h-16 rounded-full overflow-hidden ring-4 ring-[#EAEAF6] shadow-sm flex-shrink-0">
              <img
                src={`${process.env.PUBLIC_URL}/img/profile_pic.png`}
                alt="Sarah Jacob Profile Picture"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="min-w-0">
              <h2 className="text-xl font-extrabold text-[#3B3355] leading-tight truncate">
                Sarah Jacob
              </h2>

              <a
                href="mailto:sarannjac@gmail.com"
                className="mt-1 inline-flex items-center gap-2 text-[#5D5D81] hover:underline underline-offset-4"
              >
                <span className="text-sm font-medium truncate">
                  sarannjac@gmail.com
                </span>
              </a>
            </div>
          </div>

          {/* DESKTOP SIDEBAR (shown >= lg) */}
          <div className="hidden lg:block">
            <div className="flex flex-col items-start">
              <div className="w-44 h-44 rounded-full overflow-hidden shadow-sm">
                  {/* Illustrated portrait (default) */}
                    <img
                      src={`${process.env.PUBLIC_URL}/img/profile_pic.png`}
                      alt="Illustrated portrait"
                      className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-0"
                    />

                    {/* Real photo (on hover) */}
                    <img
                      src={`${process.env.PUBLIC_URL}/img/Pfp.png`}
                      alt="Sarah Jacob photo"
                      className="w-full h-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                    />
              </div>
              

              <h2 className="mt-6 text-2xl font-bold text-[#3B3355]">
                Sarah Jacob
              </h2>

              {/* Contact list */}
              <ul className="mt-5 space-y-3 text-[#5D5D81]">
                <li className="flex items-center gap-3">
                  <FontAwesomeIcon icon={faLocationDot} className="opacity-80" />
                  <span>Dallas, TX</span>
                </li>

                <li>
                  <a
                    className="flex items-center gap-3 hover:underline underline-offset-4"
                    href="mailto:sarannjac@gmail.com"
                  >
                    <FontAwesomeIcon icon={faEnvelope} className="opacity-80" />
                    <span>Email</span>
                  </a>
                </li>

                <li>
                  <a
                    className="flex items-center gap-3 hover:underline underline-offset-4"
                    href="https://www.linkedin.com/in/sarah-ann-jacob"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faLinkedinIn}
                      className="opacity-80"
                    />
                    <span>LinkedIn</span>
                  </a>
                </li>

                <li>
                  <a
                    className="flex items-center gap-3 hover:underline underline-offset-4"
                    href="https://github.com/saj62"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faGithub} className="opacity-80" />
                    <span>GitHub</span>
                  </a>
                </li>

                <li>
                  <a
                    className="flex items-center gap-3 hover:underline underline-offset-4"
                    href="https://scholar.google.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faGraduationCap}
                      className="opacity-80"
                    />
                    <span>Google Scholar</span>
                  </a>
                </li>

                <li>
                  <a
                    href="https://orcid.org/0009-0009-2327-6038"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-3 hover:underline underline-offset-4"
                  >
                    <OrcidIcon className="w-5 h-5 text-[#5D5D81] opacity-60" />
                    <span>ORCID</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </aside>

        {/* RIGHT CONTENT */}
        <main>
          <h1 className="text-5xl md:text-5xl font-extrabold text-[#3B3355]">
            About Me
          </h1>

          <div className="mt-6 space-y-5 text-[#5D5D81] leading-relaxed max-w-2xl">
            <p>
              Hi, I’m Sarah! I’m currently pursuing a Bachelor’s of Science
              (B.S.) in Computer Science from The University of Texas at Dallas.
              In high school, I decided to pursue a career that would combine my
              interests in Math and Art, finally settling on Computer Science.
            </p>

            <p>
              My main focus areas are full stack engineering and machine
              learning. I’m also exploring the exciting fields of AR/VR and
              working as an undergraduate researcher, diving into innovative
              projects that push the boundaries of technology.
            </p>

            <p>
              When I’m not building software projects, I express my creativity
              through drawing and making art. Additionally, I work as a designer
              for{" "}
              <a
                href="https://hackutd.co/"
                className="font-semibold hover:underline underline-offset-4"
                target="_blank"
                rel="noreferrer"
              >
                HackUTD
              </a>
              , where I collaborate with my team to create logos and assets for
              the largest hackathon in Texas.
            </p>
          </div>

          {/* Experience */}
          <section className="mt-12">
            <div className="mt-6">
              <Timeline />
            </div>
          </section>

          {/* Skills */}
          <section className="mt-14">
            <h2 className="text-3xl font-extrabold text-[#3B3355]">Skills</h2>
            <div className="mt-6">
              <Skills />
            </div>
          </section>
        </main>
      </div>
    </section>
  );
}
